// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"8a2f3a54","963":"8691f2cc","967":"6be84e9f"}[chunkId] + ".chunk.js";
};